"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4864,5512],{

/***/ 50297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowUp = function SvgArrowUp(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 22 13"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.414.586a2 2 0 0 1 0 2.828l-9 9a2 2 0 0 1-2.828 0l-9-9A2 2 0 1 1 3.414.586L11 8.172 18.586.586a2 2 0 0 1 2.828 0",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowUp);


/***/ }),

/***/ 833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ badge_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/badge/badge-component.scss.js


var StyledBadgeComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e18e91rw0"
})("padding:1px 8px 2px 7px;border-radius:2px;background-color:", colors/* default.brand-yellow */.Z["brand-yellow"], ";font-size:0.6875rem;color:", colors/* default.black */.Z.black, ";&.has-stroke{padding-top:0px;padding-bottom:1px;}");

;// CONCATENATED MODULE: ./components/core/badge/badge-component.js










var BadgeComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BadgeComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BadgeComponent);
    function BadgeComponent() {
        (0,_class_call_check/* default */.Z)(this, BadgeComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BadgeComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, translate = _props.translate, badgeText = _props.badgeText, badgeColorName = _props.badgeColorName, badgeTextColorName = _props.badgeTextColorName, badgeStrokeColorName = _props.badgeStrokeColorName;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadgeComponent, {
                    className: classnames_default()("core-badge-component", {
                        "has-stroke": badgeStrokeColorName
                    }),
                    style: {
                        backgroundColor: colors/* default */.Z[badgeColorName],
                        color: colors/* default */.Z[badgeTextColorName],
                        border: badgeStrokeColorName ? "1px solid ".concat(colors/* default */.Z[badgeStrokeColorName]) : "unset"
                    },
                    children: badgeText || translate("header.menuItem.popular")
                });
            }
        }
    ]);
    return BadgeComponent;
}(react.PureComponent);
/* harmony default export */ var badge_component = ((0,generic_config_context/* withGenericConfig */.P)(BadgeComponent));


/***/ }),

/***/ 25744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProgressBarComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/progressbar/progressbar-component.scss.js

var StyledProgressBarComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e6on0zn0"
})("margin-top:16px;height:2px;background-color:rgba(0,0,0,0.05);.progressbar-fill{height:100%;text-align:right;box-sizing:border-box;}.progressbar-start-animation{width:0;animation:fill-progresssbar linear;}.progressbar-stop-animation{width:100%;animation:none;}@keyframes fill-progresssbar{from{width:0%;}to{width:100%;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/progressbar/progressbar-component.js









var ProgressBarComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ProgressBarComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ProgressBarComponent);
    function ProgressBarComponent() {
        (0,_class_call_check/* default */.Z)(this, ProgressBarComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ProgressBarComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, forceProgressbarDone = _props.forceProgressbarDone, duration = _props.duration, progressbarColor = _props.progressbarColor, enabled = _props.enabled;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProgressBarComponent, {
                    className: "progressbar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()({
                            "progressbar-fill": enabled,
                            "progressbar-start-animation": !forceProgressbarDone,
                            "progressbar-stop-animation": forceProgressbarDone || !enabled
                        }),
                        style: {
                            animationDuration: "".concat(duration, "ms"),
                            backgroundColor: colors/* default */.Z[progressbarColor]
                        }
                    })
                });
            }
        }
    ]);
    return ProgressBarComponent;
}(react.PureComponent);



/***/ }),

/***/ 14158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TimerVerticalTabsDesktopComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/SwitchTransition.js
var SwitchTransition = __webpack_require__(45989);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 22 modules
var button_button = __webpack_require__(16430);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./components/core/badge/badge-component.js + 1 modules
var badge_component = __webpack_require__(833);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./static/svg/docs/arrow-up.svg
var arrow_up = __webpack_require__(50297);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/progressbar/progressbar-component.js + 1 modules
var progressbar_component = __webpack_require__(25744);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/timer-vertical-tabs-desktop/vertical-timer-tab-desktop/vertical-timer-tab-desktop-component.scss.js

var StyledVerticalTimerTabComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1x1rxwe0"
})("padding-bottom:30px;padding-top:30px;cursor:pointer;display:flex;flex-direction:column;&:first-of-type{padding-top:0;}.vertical-timer-tab-desktop-title-button{display:flex;line-height:16px;font-weight:300;padding:0;:hover{outline:0;}.vertical-timer-tab-title-badge-margin{display:inline;margin-left:8px;}.vertical-timer-tab-arrow-wrapper{flex-grow:1;text-align:end;display:flex;justify-content:flex-end;.vertical-timer-tab-arrow{width:22px;transition:0.3s transform ease-in-out;&.selected{transform:rotate(180deg);}}}}.vertical-timer-tab-desktop-title-button:hover{font-weight:500;}.vertical-timer-tab-desktop-title-button-selected{font-weight:400;margin-bottom:16px;}.vertical-timer-tab-desktop-progress-container{}.vertical-timer-tab-desktop-content-container{overflow:hidden;transition-duration:0.15s;height:0;opacity:0;transition:opacity 0.3s linear;}.vertical-timer-tab-desktop-content-container-selected{opacity:1;height:100%;}.vertical-timer-tab-desktop-content{font-size:0.875rem;line-height:22px;margin-top:8px;}&.vertical-timer-tab-desktop-container-selected{height:auto !important;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/timer-vertical-tabs-desktop/vertical-timer-tab-desktop/vertical-timer-tab-desktop-component.js





function vertical_timer_tab_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_timer_tab_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}











var VERTICAL_TAB_BUTTON_DIV_CLASS_NAME = "vertical-timer-tab-desktop-title-button";
var VerticalTimerTabComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VerticalTimerTabComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(VerticalTimerTabComponent);
    function VerticalTimerTabComponent(props) {
        (0,_class_call_check/* default */.Z)(this, VerticalTimerTabComponent);
        var _this;
        _this = _super.call(this, props);
        vertical_timer_tab_desktop_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "handleTitleClick", function() {
            var _props = _this.props, setSelectedTab = _props.setSelectedTab, index = _props.index, title = _props.title, getTabIdentifier = _props.getTabIdentifier, isSelected = _props.isSelected;
            var identifier = getTabIdentifier ? getTabIdentifier(_this.props) : title;
            BigBrain("track", bigbrain_event_types.TAB_CLICKED, {
                kind: identifier,
                info1: index,
                info2: isSelected
            });
            setSelectedTab(index);
        });
        vertical_timer_tab_desktop_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onTabClicked", function(e) {
            _this.blurTab(e);
            _this.handleTitleClick();
        });
        vertical_timer_tab_desktop_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "blurTab", function(e) {
            var _e_target_closest, _e_target;
            e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".".concat(VERTICAL_TAB_BUTTON_DIV_CLASS_NAME))) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
        });
        vertical_timer_tab_desktop_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "shouldShowProgressbar", function() {
            var _props = _this.props, isSelected = _props.isSelected, timerEnabled = _props.timerEnabled, alwaysShowProgressbar = _props.alwaysShowProgressbar;
            return alwaysShowProgressbar || timerEnabled && isSelected;
        });
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.handleTitleClick);
        return _this;
    }
    (0,_create_class/* default */.Z)(VerticalTimerTabComponent, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, title = _this_props.title, tabTitleRenderer = _this_props.tabTitleRenderer, tabContentRenderer = _this_props.tabContentRenderer, content = _this_props.content, badgeText = _this_props.badgeText, fontColor = _this_props.fontColor, selectedFontColor = _this_props.selectedFontColor, titleFontWeight = _this_props.titleFontWeight, fontSize = _this_props.fontSize, selectedFontSize = _this_props.selectedFontSize, lineHeight = _this_props.lineHeight, isSelected = _this_props.isSelected, forceProgressbarDone = _this_props.forceProgressbarDone, duration = _this_props.duration, showArrow = _this_props.showArrow, progressbarColor = _this_props.progressbarColor, arrowSize = _this_props.arrowSize, timerEnabled = _this_props.timerEnabled, rest = _object_without_properties(_this_props, [
                    "title",
                    "tabTitleRenderer",
                    "tabContentRenderer",
                    "content",
                    "badgeText",
                    "fontColor",
                    "selectedFontColor",
                    "titleFontWeight",
                    "fontSize",
                    "selectedFontSize",
                    "lineHeight",
                    "isSelected",
                    "forceProgressbarDone",
                    "duration",
                    "showArrow",
                    "progressbarColor",
                    "arrowSize",
                    "timerEnabled"
                ]);
                var color = isSelected ? colors/* default */.Z[selectedFontColor] : colors/* default */.Z[fontColor];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledVerticalTimerTabComponent, {
                    tabIndex: 0,
                    role: "button",
                    className: classnames_default()("vertical-timer-tab-desktop-container", {
                        "vertical-timer-tab-desktop-container-selected": isSelected
                    }),
                    onClick: this.onTabClicked,
                    onKeyDown: this.onKeyDown,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()(VERTICAL_TAB_BUTTON_DIV_CLASS_NAME, {
                                "vertical-timer-tab-desktop-title-button-selected": isSelected
                            }),
                            style: {
                                fontSize: isSelected ? selectedFontSize : fontSize
                            },
                            children: [
                                tabTitleRenderer ? tabTitleRenderer(title, _object_spread_props(_object_spread({}, rest), {
                                    isSelected: isSelected
                                })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                    tagName: "span",
                                    style: {
                                        color: color,
                                        fontWeight: titleFontWeight,
                                        lineHeight: lineHeight
                                    },
                                    text: title
                                }),
                                badgeText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "vertical-timer-tab-title-badge-margin",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_component/* default */.Z, {
                                        badgeText: badgeText
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "vertical-timer-tab-arrow-wrapper",
                                    children: showArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_up/* default */.Z, {
                                        className: classnames_default()("vertical-timer-tab-arrow", {
                                            selected: isSelected
                                        }),
                                        style: {
                                            color: color,
                                            width: arrowSize
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("vertical-timer-tab-desktop-progress-container"),
                            children: this.shouldShowProgressbar() && /*#__PURE__*/ (0,jsx_runtime.jsx)(progressbar_component/* default */.Z, {
                                duration: duration,
                                forceProgressbarDone: forceProgressbarDone || !timerEnabled,
                                progressbarColor: progressbarColor,
                                enabled: isSelected
                            })
                        }),
                        (content || tabContentRenderer) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("vertical-timer-tab-desktop-content-container", {
                                "vertical-timer-tab-desktop-content-container-selected": isSelected
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "vertical-timer-tab-desktop-content",
                                children: tabContentRenderer ? tabContentRenderer(content, _object_spread({}, rest)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                    text: content
                                })
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return VerticalTimerTabComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
var constants_default = /*#__PURE__*/__webpack_require__.n(constants);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/timer-vertical-tabs-desktop/timer-vertical-tabs-desktop-component.scss.js




var CONTAINER_HEIGHT = 550;
var CONTAINER_HEIGHT_PX = "".concat(CONTAINER_HEIGHT, "px");
var BODY_HORIZONTAL_PADDING = "".concat((constants_default()).BODY_CONTENT_HORIZONTAL_PADDING, "px");
var StyledTimerVerticalTabsDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e306sie0"
})("max-width:", vp_sizes/* MAX_DESKTOP_GRID_WIDTH */.sk, "px;width:85%;margin:0 auto;padding:8px 0px;.tabs-divider{border-top:1px solid ", colors/* default.gainsboro */.Z.gainsboro, ";width:100%;opacity:0.5;}.tabs-paragraph-wrapper{margin-bottom:45px;}.vertical-timer-tabs-container{display:flex;.right-side-container{position:relative;.right-side-tab-content-container{width:100%;height:100%;position:absolute;display:flex;justify-content:center;align-items:center;&.hidden{opacity:0;}}}.desktop-tabs-text-container{margin-right:75px;min-height:", CONTAINER_HEIGHT_PX, ";display:flex;flex-direction:column;justify-content:center;}.desktop-asset-container{display:flex;flex-direction:column;justify-content:center;.tab-asset-inner{align-self:flex-end;display:flex;width:760px;height:", CONTAINER_HEIGHT_PX, ";padding:28px;.tab-asset-image{max-width:100%;max-height:", CONTAINER_HEIGHT_PX, ";width:auto;}}}.fade-enter{opacity:0;}.fade-exit{opacity:1;}.fade-enter-active{opacity:1;}.fade-exit-active{opacity:0;}.fade-enter-active,.fade-exit-active{transition:opacity 200ms;}}.button-link{margin-top:40px;}&.full-screen{width:100%;max-width:", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI + "px", ";padding:0;.vertical-timer-tabs-container{display:grid;grid-template-columns:1fr 1fr;margin-left:16px;margin-right:16px;.desktop-asset-container{.tab-asset-inner{height:100%;width:100%;padding:0;align-self:center;}}.desktop-tabs-text-container{box-sizing:content-box;padding-left:", "calc(max(min(100vw, ".concat(vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, "px) - ").concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px, 0px) / 2 + ").concat(BODY_HORIZONTAL_PADDING, ")"), ";padding-right:60px;padding-top:64px;padding-bottom:64px;max-width:", "calc((".concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px - ").concat(BODY_HORIZONTAL_PADDING, " * 2) / 2) })"), ";}}.vertical-timer-tabs-container{.desktop-tabs-text-container{.tab{transition:opacity 0.3s ease;.vertical-timer-tab-desktop-title-button{opacity:0.4;}.vertical-timer-tab-desktop-title-button-selected{opacity:1;}&:hover{.vertical-timer-tab-desktop-title-button{opacity:1;}}}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/constants/timer.js
var constants_timer = __webpack_require__(39849);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/timer-vertical-tabs-desktop/timer-vertical-tabs-desktop-component.js






function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timer_vertical_tabs_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function timer_vertical_tabs_desktop_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function timer_vertical_tabs_desktop_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        timer_vertical_tabs_desktop_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function timer_vertical_tabs_desktop_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = timer_vertical_tabs_desktop_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function timer_vertical_tabs_desktop_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}












var TimerVerticalTabsDesktopComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TimerVerticalTabsDesktopComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TimerVerticalTabsDesktopComponent);
    function TimerVerticalTabsDesktopComponent(props) {
        (0,_class_call_check/* default */.Z)(this, TimerVerticalTabsDesktopComponent);
        var _this;
        _this = _super.call(this, props);
        var _props = _this.props, isCollapsable = _props.isCollapsable, selectedTabIndex = _props.selectedTabIndex;
        _this.state = {
            selectedTab: (selectedTabIndex !== null && selectedTabIndex !== void 0 ? selectedTabIndex : isCollapsable) ? null : 0,
            forceProgressbarDone: false
        };
        _this.tabsInterval = null;
        _this.handleOnMouseLeave = _this.handleOnMouseLeave.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleOnMouseOver = _this.handleOnMouseOver.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.setSelectedTab = _this.setSelectedTab.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.startTabInterval = _this.startTabInterval.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.clearTabInterval = _this.clearTabInterval.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.startInterval = _this.startInterval.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.stopInterval = _this.stopInterval.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderTabs = _this.renderTabs.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(TimerVerticalTabsDesktopComponent, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var selectedTabIndex = this.props.selectedTabIndex;
                selectedTabIndex !== prevProps.selectedTabIndex && this.setState({
                    selectedTab: selectedTabIndex
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, timerEnabled = _props.timerEnabled, onTabChangedHandler = _props.onTabChangedHandler, tabs = _props.tabs;
                var selectedTab = this.state.selectedTab;
                onTabChangedHandler === null || onTabChangedHandler === void 0 ? void 0 : onTabChangedHandler(tabs[selectedTab]);
                if (!timerEnabled) return;
                this.startInterval();
            }
        },
        {
            key: "handleOnMouseOver",
            value: function handleOnMouseOver() {
                var timerEnabled = this.props.timerEnabled;
                if (!timerEnabled) return;
                this.setState({
                    forceProgressbarDone: true
                });
                this.stopInterval();
            }
        },
        {
            key: "handleOnMouseLeave",
            value: function handleOnMouseLeave() {
                var timerEnabled = this.props.timerEnabled;
                if (!timerEnabled) return;
                this.setState({
                    forceProgressbarDone: false
                });
                this.startInterval();
            }
        },
        {
            key: "setSelectedTab",
            value: function setSelectedTab(newSelectedTab) {
                var _props = this.props, isCollapsable = _props.isCollapsable, onTabChangedHandler = _props.onTabChangedHandler, tabs = _props.tabs;
                var selectedTab = this.state.selectedTab;
                var tabToSelect = isCollapsable && newSelectedTab === selectedTab ? null : newSelectedTab;
                onTabChangedHandler === null || onTabChangedHandler === void 0 ? void 0 : onTabChangedHandler(tabs[tabToSelect]);
                this.setState({
                    selectedTab: tabToSelect,
                    forceProgressbarDone: false
                });
                this.startInterval();
            }
        },
        {
            key: "startTabInterval",
            value: function startTabInterval() {
                var _this = this;
                var _tabs_selectedTab;
                var selectedTab = this.state.selectedTab;
                var _props = this.props, tabs = _props.tabs, isCollapsable = _props.isCollapsable;
                if (isCollapsable) return;
                this.tabsInterval = setInterval(function() {
                    var nextTab = (selectedTab + 1) % tabs.length;
                    _this.setSelectedTab(nextTab);
                }, parseInt((_tabs_selectedTab = tabs[selectedTab]) === null || _tabs_selectedTab === void 0 ? void 0 : _tabs_selectedTab.timer) || constants_timer/* DEFAULT_TAB_TIMER */.d);
            }
        },
        {
            key: "clearTabInterval",
            value: function clearTabInterval() {
                var isCollapsable = this.props.isCollapsable;
                if (isCollapsable) return;
                clearInterval(this.tabsInterval);
            }
        },
        {
            key: "startInterval",
            value: function startInterval() {
                var timerEnabled = this.props.timerEnabled;
                if (timerEnabled) {
                    this.stopInterval();
                    this.startTabInterval();
                }
            }
        },
        {
            key: "stopInterval",
            value: function stopInterval() {
                var timerEnabled = this.props.timerEnabled;
                if (timerEnabled) {
                    this.clearTabInterval();
                }
            }
        },
        {
            key: "renderTabs",
            value: function renderTabs() {
                var _this = this;
                var _state = this.state, selectedTab = _state.selectedTab, forceProgressbarDone = _state.forceProgressbarDone;
                var _props = this.props, tabs = _props.tabs, showDivider = _props.showDivider, timerEnabled = _props.timerEnabled, tabContentRenderer = _props.tabContentRenderer, showArrow = _props.showArrow, progressbarColor = _props.progressbarColor, alwaysShowProgressbar = _props.alwaysShowProgressbar, arrowSize = _props.arrowSize, tabTitleRenderer = _props.tabTitleRenderer, title = _props.title, getTabIdentifier = _props.getTabIdentifier;
                var ref = title || {}, fontSize = ref.fontSize, selectedFontSize = ref.selectedFontSize, fontColor = ref.fontColor, selectedFontColor = ref.selectedFontColor, fontWeight = ref.fontWeight, lineHeight = ref.lineHeight;
                return tabs.map(function(tab, index) {
                    var title = tab.title, content = tab.content, badgeText = tab.badgeText, timer = tab.timer, overrideTabFontColor = tab.overrideTabFontColor, rest = timer_vertical_tabs_desktop_component_object_without_properties(tab, [
                        "title",
                        "content",
                        "badgeText",
                        "timer",
                        "overrideTabFontColor"
                    ]);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tab",
                        role: "tablist",
                        children: [
                            showDivider && index != 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tabs-divider"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalTimerTabComponent, timer_vertical_tabs_desktop_component_object_spread({
                                index: index,
                                getTabIdentifier: getTabIdentifier,
                                isSelected: index === selectedTab,
                                title: title,
                                content: content,
                                badgeText: badgeText,
                                duration: timer || constants_timer/* DEFAULT_TAB_TIMER */.d,
                                forceProgressbarDone: forceProgressbarDone,
                                setSelectedTab: _this.setSelectedTab,
                                showArrow: showArrow,
                                timerEnabled: timerEnabled,
                                fontSize: fontSize,
                                lineHeight: lineHeight,
                                selectedFontSize: selectedFontSize,
                                fontColor: overrideTabFontColor !== null && overrideTabFontColor !== void 0 ? overrideTabFontColor : fontColor,
                                selectedFontColor: overrideTabFontColor !== null && overrideTabFontColor !== void 0 ? overrideTabFontColor : selectedFontColor,
                                progressbarColor: progressbarColor,
                                alwaysShowProgressbar: alwaysShowProgressbar,
                                arrowSize: arrowSize,
                                tabTitleRenderer: tabTitleRenderer,
                                tabContentRenderer: tabContentRenderer,
                                titleFontWeight: fontWeight
                            }, rest))
                        ]
                    }, index);
                });
            }
        },
        {
            key: "renderAllRightSideContent",
            value: function renderAllRightSideContent() {
                var _this = this;
                var tabs = this.props.tabs;
                var selectedTab = this.state.selectedTab;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "right-side-container",
                    children: tabs.map(function(tab, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("right-side-tab-content-container", {
                                hidden: index !== selectedTab
                            }),
                            children: _this.renderRightSide(index)
                        }, index);
                    })
                });
            }
        },
        {
            key: "renderRightSide",
            value: function renderRightSide(selectedTab) {
                var _tabs_selectedTab, _tabs_selectedTab_asset_image, _tabs_selectedTab_asset, _tabs_selectedTab_asset_video, _tabs_selectedTab_asset1, _tabs_selectedTab1, _tabs_selectedTab2;
                var _props = this.props, assetQuality = _props.assetQuality, hideControls = _props.hideControls, useWindowMask = _props.useWindowMask, tabs = _props.tabs, backgroundColor = _props.backgroundColor, rightSideRenderer = _props.rightSideRenderer, assetPosition = _props.assetPosition;
                var shouldDisplayImage = ((_tabs_selectedTab = tabs[selectedTab]) === null || _tabs_selectedTab === void 0 ? void 0 : _tabs_selectedTab.asset) && ((_tabs_selectedTab_asset = tabs[selectedTab].asset) === null || _tabs_selectedTab_asset === void 0 ? void 0 : (_tabs_selectedTab_asset_image = _tabs_selectedTab_asset.image) === null || _tabs_selectedTab_asset_image === void 0 ? void 0 : _tabs_selectedTab_asset_image.src) || ((_tabs_selectedTab1 = tabs[selectedTab]) === null || _tabs_selectedTab1 === void 0 ? void 0 : (_tabs_selectedTab_asset1 = _tabs_selectedTab1.asset) === null || _tabs_selectedTab_asset1 === void 0 ? void 0 : (_tabs_selectedTab_asset_video = _tabs_selectedTab_asset1.video) === null || _tabs_selectedTab_asset_video === void 0 ? void 0 : _tabs_selectedTab_asset_video.src);
                if (!shouldDisplayImage && rightSideRenderer) return rightSideRenderer(tabs[selectedTab]);
                var assetPositionStyle = (0,images_grid_service/* getImagePositionStyles */.y)(assetPosition);
                var assetInnerStyle = timer_vertical_tabs_desktop_component_object_spread_props(timer_vertical_tabs_desktop_component_object_spread({}, assetPositionStyle), {
                    backgroundColor: colors/* default */.Z[backgroundColor]
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "desktop-asset-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, timer_vertical_tabs_desktop_component_object_spread_props(timer_vertical_tabs_desktop_component_object_spread({}, (_tabs_selectedTab2 = tabs[selectedTab]) === null || _tabs_selectedTab2 === void 0 ? void 0 : _tabs_selectedTab2.asset), {
                        assetQuality: assetQuality,
                        hideControls: hideControls,
                        useWindowMask: useWindowMask,
                        convertGifToVideo: true,
                        className: "tab-asset-inner",
                        imageClassName: "tab-asset-image",
                        style: assetInnerStyle
                    }))
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, showButton = _props.showButton, buttonConfig = _props.buttonConfig, isFullScreen = _props.isFullScreen, tabsTitle = _props.tabsTitle, tabsContainerClassName = _props.tabsContainerClassName, isTabsFullWidth = _props.isTabsFullWidth, prerenderTabs = _props.prerenderTabs;
                var selectedTab = this.state.selectedTab;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTimerVerticalTabsDesktopComponent, {
                    className: classnames_default()("timer-vertical-tabs-desktop-component", {
                        "full-screen": isFullScreen
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "vertical-timer-tabs-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()("desktop-tabs-text-container", (0,_define_property/* default */.Z)({}, tabsContainerClassName, tabsContainerClassName)),
                                    style: {
                                        width: isTabsFullWidth && "100%"
                                    },
                                    onFocus: this.handleOnMouseOver,
                                    onBlur: this.handleOnMouseLeave,
                                    onMouseOver: this.handleOnMouseOver,
                                    onMouseLeave: this.handleOnMouseLeave,
                                    children: [
                                        (tabsTitle === null || tabsTitle === void 0 ? void 0 : tabsTitle.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tabs-paragraph-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, timer_vertical_tabs_desktop_component_object_spread({}, tabsTitle))
                                        }),
                                        this.renderTabs()
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchTransition/* default */.Z, {
                                    mode: "out-in",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                                        classNames: "fade",
                                        timeout: 200,
                                        children: prerenderTabs ? this.renderAllRightSideContent() : this.renderRightSide(selectedTab)
                                    }, selectedTab)
                                })
                            ]
                        }),
                        showButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "button-link",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, timer_vertical_tabs_desktop_component_object_spread({}, buttonConfig))
                        })
                    ]
                });
            }
        }
    ]);
    return TimerVerticalTabsDesktopComponent;
}(react.PureComponent);



/***/ }),

/***/ 39849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ONE_SECOND; },
/* harmony export */   "d": function() { return /* binding */ DEFAULT_TAB_TIMER; }
/* harmony export */ });
var ONE_SECOND = 1000;
var DEFAULT_TAB_TIMER = ONE_SECOND * 10;


/***/ }),

/***/ 83246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constants_timer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39849);
/* harmony import */ var segments_desktop_core_components_images_grid_images_grid_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72898);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(273);



var getAsset = function(videoName) {
    return {
        video: {
            loop: false,
            src: {
                formats: [
                    "/static/video/capabilites_videos/".concat(videoName, ".mp4")
                ]
            }
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    tabs: [
        {
            title: "Flexible Database",
            content: "A Work OS is flexible enough to fit any team, workflow, or industry. With intuitive analytics, you can run your daily work, analyze your performance, and manage your team in one place. ",
            timer: _constants_timer__WEBPACK_IMPORTED_MODULE_0__/* .ONE_SECOND */ .W * 10,
            asset: getAsset("flexibility")
        },
        {
            title: "Insights & reporting",
            content: "Track progress and understand how your team is working in a single glance with contextual insights.",
            timer: _constants_timer__WEBPACK_IMPORTED_MODULE_0__/* .ONE_SECOND */ .W * 10,
            asset: getAsset("insight")
        },
        {
            title: "Data visualization",
            content: "See organization-wide insights and drill down into the details using flexible dashboards.",
            timer: _constants_timer__WEBPACK_IMPORTED_MODULE_0__/* .ONE_SECOND */ .W * 7,
            asset: getAsset("data-viz")
        },
        {
            title: "Organization-wide use",
            content: "Meet the needs of all your teams and run processes, gain insights, and communicate all in one place.",
            timer: _constants_timer__WEBPACK_IMPORTED_MODULE_0__/* .ONE_SECOND */ .W * 6,
            asset: getAsset("organization-wide-use")
        },
        {
            title: "Collaboration",
            content: "Share knowledge and collaborate within the context of your work. ",
            timer: _constants_timer__WEBPACK_IMPORTED_MODULE_0__/* .ONE_SECOND */ .W * 7,
            asset: getAsset("colaboration")
        },
        {
            title: "Integrations",
            content: "Integrate with your favorite tools and build diverse workflows from start to finish. ",
            timer: _constants_timer__WEBPACK_IMPORTED_MODULE_0__/* .ONE_SECOND */ .W * 8,
            asset: getAsset("integrations")
        },
        {
            title: "Automations",
            content: "Put mundane tasks on autopilot so teams can focus on the work that makes an impact.",
            timer: _constants_timer__WEBPACK_IMPORTED_MODULE_0__/* .ONE_SECOND */ .W * 12,
            asset: getAsset("automations")
        },
        {
            title: "Working remotely",
            content: "Collaborate, track statuses, give feedback, outline projects, and define ownership for your projects, processes, and workflows no matter where you are.",
            timer: _constants_timer__WEBPACK_IMPORTED_MODULE_0__/* .ONE_SECOND */ .W * 5,
            badgeText: "Popular",
            asset: getAsset("working-remotely")
        }
    ],
    backgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_2__.LIGHT_BLUE_VIDEO_BACKGROUND_COLOR_NAME,
    progressbarColor: "brand-green",
    showArrow: false,
    assetPosition: segments_desktop_core_components_images_grid_images_grid_service__WEBPACK_IMPORTED_MODULE_1__/* .positionTypes.BOTTOM_CENTER */ .b.BOTTOM_CENTER,
    showButton: true,
    buttonConfig: {
        buttonType: "YouTube Popup",
        isWithIcon: true,
        buttonText: "Watch monday.com in action",
        iconColor: "green"
    },
    timerEnabled: true,
    alwaysShowProgressbar: false,
    arrowSize: "22px",
    title: {
        fontSize: "16px",
        selectedFontSize: "20px"
    }
});


/***/ }),

/***/ 34864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ vertical_timer_tabs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/timer-vertical-tabs-desktop/timer-vertical-tabs-desktop-component.js + 3 modules
var timer_vertical_tabs_desktop_component = __webpack_require__(14158);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 22 modules
var button_button = __webpack_require__(16430);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/timer-vertical-tabs-mobile/timer-verticals-tabs-mobile-component.scss.js

var StyledTimerVerticalTabsMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e11me76v0"
})("display:flex;flex-direction:column;padding:32px 40px;.mobile-tabs-title-wrapper{margin-bottom:48px;}.mobile-button-link{padding:16px 0;}");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./static/svg/docs/arrow-up.svg
var arrow_up = __webpack_require__(50297);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./components/core/badge/badge-component.js + 1 modules
var badge_component = __webpack_require__(833);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./utils/dom.js
var dom = __webpack_require__(5512);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/timer-vertical-tabs-mobile/vertical-timer-tab-mobile/vertical-timer-tab-mobile-component.scss.js

var StyledVerticalTimerTabMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16e28ki0"
})("padding-bottom:16px;.vertical-timer-tab-mobile-title{display:flex;align-items:center;cursor:pointer;line-height:22px;font-weight:300;font-size:0.875rem;padding:0;.vertical-timer-tab-mobile-title-badge-margin{display:inline;margin-left:8px;}.vertical-timer-tab-arrow-wrapper{flex-grow:1;text-align:end;.vertical-timer-tab-arrow{width:22px;transition:0.3s transform ease-in-out;&.selected{transform:rotate(180deg);}}}}.vertical-timer-tab-mobile-title-selected{font-style:normal;font-weight:bold;font-size:1.125rem;line-height:22px;padding:0 0 16px 0;}.vertical-timer-tab-mobile-progress-container{margin-bottom:16px;}.vertical-timer-tab-mobile-content-container{height:0;opacity:0;transition:opacity 0.3s linear;.vertical-timer-tab-mobile-content{padding-bottom:16px;line-height:22px;font-weight:300;font-size:0.875rem;}.vertical-timer-tab-mobile-asset{padding:10px;}}.vertical-timer-tab-mobile-content-container-selected{height:100%;opacity:1;}");

// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/progressbar/progressbar-component.js + 1 modules
var progressbar_component = __webpack_require__(25744);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/timer-vertical-tabs-mobile/vertical-timer-tab-mobile/vertical-timer-tab-mobile-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}














var VerticalTimerTabMobileComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VerticalTimerTabMobileComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(VerticalTimerTabMobileComponent);
    function VerticalTimerTabMobileComponent(props) {
        (0,_class_call_check/* default */.Z)(this, VerticalTimerTabMobileComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "handleTitleClick", function() {
            var _props = _this.props, setSelectedTab = _props.setSelectedTab, index = _props.index, title = _props.title, getTabIdentifier = _props.getTabIdentifier, isSelected = _props.isSelected;
            var identifier = getTabIdentifier ? getTabIdentifier(_this.props) : title;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.TAB_CLICKED, {
                kind: identifier,
                info1: index,
                info2: isSelected
            });
            setSelectedTab(index);
        });
        _this.tabRef = /*#__PURE__*/ (0,react.createRef)();
        return _this;
    }
    (0,_create_class/* default */.Z)(VerticalTimerTabMobileComponent, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState, snapshot) {
                var isSelected = this.props.isSelected;
                if (isSelected && isSelected !== prevProps.isSelected) {
                    (0,dom/* scrollIntoViewWithOffset */.H)(this.tabRef, constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT);
                }
            }
        },
        {
            key: "renderRightSide",
            value: function renderRightSide() {
                var _asset_image, _asset_video;
                var _props = this.props, assetQuality = _props.assetQuality, asset = _props.asset, rightSideRenderer = _props.rightSideRenderer, backgroundColor = _props.backgroundColor;
                var shouldDisplayImage = asset && (asset === null || asset === void 0 ? void 0 : (_asset_image = asset.image) === null || _asset_image === void 0 ? void 0 : _asset_image.src) || (asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : _asset_video.src);
                if (!shouldDisplayImage && rightSideRenderer) return rightSideRenderer(this.props);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "vertical-timer-tab-mobile-asset",
                    style: {
                        backgroundColor: colors/* default */.Z[backgroundColor]
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread_props(_object_spread({}, asset), {
                        assetQuality: assetQuality,
                        convertGifToVideo: true
                    }))
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, title = _this_props.title, tabContentRenderer = _this_props.tabContentRenderer, content = _this_props.content, badgeText = _this_props.badgeText, fontColor = _this_props.fontColor, selectedFontColor = _this_props.selectedFontColor, titleFontWeight = _this_props.titleFontWeight, fontSize = _this_props.fontSize, selectedFontSize = _this_props.selectedFontSize, tabTitleRenderer = _this_props.tabTitleRenderer, rest = _object_without_properties(_this_props, [
                    "title",
                    "tabContentRenderer",
                    "content",
                    "badgeText",
                    "fontColor",
                    "selectedFontColor",
                    "titleFontWeight",
                    "fontSize",
                    "selectedFontSize",
                    "tabTitleRenderer"
                ]);
                var _props = this.props, isSelected = _props.isSelected, alwaysShowProgressbar = _props.alwaysShowProgressbar, showArrow = _props.showArrow, progressbarColor = _props.progressbarColor, arrowSize = _props.arrowSize, lineHeight = _props.lineHeight;
                var color = isSelected ? colors/* default */.Z[selectedFontColor] : colors/* default */.Z[fontColor];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledVerticalTimerTabMobileComponent, {
                    className: "vertical-timer-tab-mobile-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            ref: this.tabRef,
                            className: classnames_default()("vertical-timer-tab-mobile-title", {
                                "vertical-timer-tab-mobile-title-selected": isSelected
                            }),
                            onClick: this.handleTitleClick,
                            style: {
                                fontSize: isSelected ? selectedFontSize : fontSize
                            },
                            children: [
                                tabTitleRenderer ? tabTitleRenderer(title, _object_spread({}, rest)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                    tagName: "span",
                                    style: {
                                        color: color,
                                        fontWeight: titleFontWeight,
                                        lineHeight: lineHeight
                                    },
                                    text: title
                                }),
                                badgeText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "vertical-timer-tab-mobile-title-badge-margin",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_component/* default */.Z, {
                                        badgeText: badgeText
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "vertical-timer-tab-arrow-wrapper",
                                    children: showArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_up/* default */.Z, {
                                        className: classnames_default()("vertical-timer-tab-arrow", {
                                            selected: isSelected
                                        }),
                                        style: {
                                            color: color,
                                            width: arrowSize
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "vertical-timer-tab-mobile-progress-container",
                            children: alwaysShowProgressbar && /*#__PURE__*/ (0,jsx_runtime.jsx)(progressbar_component/* default */.Z, {
                                forceProgressbarDone: true,
                                progressbarColor: progressbarColor,
                                enabled: isSelected
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("vertical-timer-tab-mobile-content-container", {
                                "vertical-timer-tab-mobile-content-container-selected": isSelected
                            }),
                            children: isSelected ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "vertical-timer-tab-mobile-content",
                                        children: tabContentRenderer ? tabContentRenderer(content, _object_spread({}, rest)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                            text: content
                                        })
                                    }),
                                    this.renderRightSide()
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        })
                    ]
                });
            }
        }
    ]);
    return VerticalTimerTabMobileComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/timer-vertical-tabs-mobile/timer-verticals-tabs-mobile-component.js





function timer_verticals_tabs_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timer_verticals_tabs_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timer_verticals_tabs_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function timer_verticals_tabs_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function timer_verticals_tabs_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        timer_verticals_tabs_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var TimerVerticalTabsMobileComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TimerVerticalTabsMobileComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TimerVerticalTabsMobileComponent);
    function TimerVerticalTabsMobileComponent(props) {
        (0,_class_call_check/* default */.Z)(this, TimerVerticalTabsMobileComponent);
        var _this;
        _this = _super.call(this, props);
        timer_verticals_tabs_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "setSelectedTab", function(newSelectedTab) {
            var timerEnabled = _this.props.timerEnabled;
            _this.setState(function(prevState) {
                return {
                    selectedTab: !timerEnabled && prevState.selectedTab === newSelectedTab ? null : newSelectedTab
                };
            });
        });
        timer_verticals_tabs_mobile_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderTabs", function() {
            var selectedTab = _this.state.selectedTab;
            var _props = _this.props, tabs = _props.tabs, tabContentRenderer = _props.tabContentRenderer, assetQuality = _props.assetQuality, title = _props.title, showArrow = _props.showArrow, progressbarColor = _props.progressbarColor, rightSideRenderer = _props.rightSideRenderer, alwaysShowProgressbar = _props.alwaysShowProgressbar, arrowSize = _props.arrowSize, backgroundColor = _props.backgroundColor, tabTitleRenderer = _props.tabTitleRenderer, getTabIdentifier = _props.getTabIdentifier;
            var ref = title || {}, fontSize = ref.fontSize, selectedFontSize = ref.selectedFontSize, fontColor = ref.fontColor, selectedFontColor = ref.selectedFontColor, fontWeight = ref.fontWeight;
            return tabs.map(function(tab, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalTimerTabMobileComponent, timer_verticals_tabs_mobile_component_object_spread_props(timer_verticals_tabs_mobile_component_object_spread({
                    index: index
                }, tab), {
                    getTabIdentifier: getTabIdentifier,
                    isSelected: index === selectedTab,
                    setSelectedTab: _this.setSelectedTab,
                    assetQuality: assetQuality,
                    rightSideRenderer: rightSideRenderer,
                    showArrow: showArrow,
                    tabContentRenderer: tabContentRenderer,
                    fontSize: fontSize,
                    tabTitleRenderer: tabTitleRenderer,
                    selectedFontSize: selectedFontSize,
                    fontColor: fontColor,
                    selectedFontColor: selectedFontColor,
                    titleFontWeight: fontWeight,
                    progressbarColor: progressbarColor,
                    alwaysShowProgressbar: alwaysShowProgressbar,
                    arrowSize: arrowSize,
                    backgroundColor: backgroundColor
                }), index);
            });
        });
        _this.state = {
            selectedTab: 0
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(TimerVerticalTabsMobileComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, showButton = _props.showButton, buttonConfig = _props.buttonConfig, tabsTitle = _props.tabsTitle;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTimerVerticalTabsMobileComponent, {
                    className: "mobile-timer-tabs-component",
                    children: [
                        tabsTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-tabs-title-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, timer_verticals_tabs_mobile_component_object_spread({}, tabsTitle))
                        }),
                        this.renderTabs(),
                        showButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-button-link",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, timer_verticals_tabs_mobile_component_object_spread({}, buttonConfig))
                        })
                    ]
                });
            }
        }
    ]);
    return TimerVerticalTabsMobileComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs.scss.js


var mdScreenSize = vp_sizes.MD + "px";
var StyledVerticalTimerTabs = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1v6ds5u0"
})(".desktop-wrapper{display:block;}.mobile-wrapper{display:none;}@media (max-width:", mdScreenSize, "){.desktop-wrapper{display:none;}.mobile-wrapper{display:block;}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/default-props.js
var default_props = __webpack_require__(83246);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs.js
function vertical_timer_tabs_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_timer_tabs_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_timer_tabs_define_property(target, key, source[key]);
        });
    }
    return target;
}





var VerticalTimerTabs = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledVerticalTimerTabs, {
        className: "vertical-timer-tabs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "desktop-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(timer_vertical_tabs_desktop_component/* default */.Z, vertical_timer_tabs_object_spread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimerVerticalTabsMobileComponent, vertical_timer_tabs_object_spread({}, props))
            })
        ]
    });
};
VerticalTimerTabs.defaultProps = default_props/* default */.Z;
/* harmony default export */ var vertical_timer_tabs = (VerticalTimerTabs);


/***/ }),

/***/ 5512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ scrollIntoViewWithOffset; },
/* harmony export */   "l": function() { return /* binding */ isEventTargetSpecificTag; }
/* harmony export */ });
var isEventTargetSpecificTag = function(event, tagName) {
    return event.target.tagName.toUpperCase() === tagName.toUpperCase();
};
var scrollIntoViewWithOffset = function(ref, offset) {
    window.scrollTo({
        behavior: "smooth",
        top: (ref === null || ref === void 0 ? void 0 : ref.current.getBoundingClientRect().top) - document.body.getBoundingClientRect().top - offset
    });
};


/***/ })

}]);